import { Component } from '@angular/core';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { categories } from '@AppRoot/shared/models/common.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  partners = [
    {
      logo: 'https://images.mashhoorplus.in/file/Flipkart-Logo-2007-2015.png',
      url: 'https://shorturl.at/1NHYh',
    },
    {
      logo: 'https://images.mashhoorplus.in/file/amzn.jpg',
      url: 'https://shorturl.at/1NHYh',
    },
  ];

  social = [
    {
      logo: 'https://images.mashhoorplus.in/file/icons8-instagram-logo-94.png',
      url: 'https://www.instagram.com/mashhoorplus/',
    },
    {
      logo: 'https://images.mashhoorplus.in/file/icons8-whatsapp-logo-94.png',
      url: 'https://wa.me/+918273363610',
    },
    {
      logo: 'https://images.mashhoorplus.in/file/1745322096471youtube-logo-png-2069.png',
      url: 'https://www.youtube.com/@MashhoorPlus',
    },
  ];

  shopCategories: Array<categories> = [];
  constructor(
    private sharedService: SharedService,
    private _globalUtilityService: GlobalUtilityService
  ) {}
  ngOnInit() {
    this.sharedService.categoryList.subscribe({
      next: (res) => {
        this.shopCategories = res;
      },
    });
  }

  redirectToProduct(category_id: number) {
    this._globalUtilityService.navigateToPath(`/products`, { category_id });
  }
}
